import React from 'react';
import {Link} from 'react-router';
import ReactDataSheet from 'react-datasheet';
import FirebaseApi from '../../api/firebase'

import {year_wages, brp_bonus_wages} from '../home/wages'
import {year_2018_proportions_new, year_2018_proportions, headship_hours} from '../home/restrictions.js'
import {glosary, glosary_abreviations} from '../home/glosary'
import {san_jose_schedule, san_joaquin_schedule, san_jose_type, san_joaquin_type, san_juan_type} from '../home/schedules.js'



import ReactHTMLTableToExcel from 'react-html-table-to-excel';



class Updater extends React.Component {

	constructor (props)  {
		super(props)
    	//this.state = props.contractInfo
    	this.state = {
    		loading: false,
    		exportData: []
    	}
	}

	componentWillMount = () => {
	}

	fetchContracts = () => {
		this.setState({loading: true})
		let contracts = []
		FirebaseApi.GetValues('/contracts').then( (snap) => {
      		let contractsObj = snap.val()
      		if(contractsObj) {
        		Object.keys(contractsObj).forEach( (key) => {
          		this.updateContract(contractsObj[key])
        		})
      		}
      		this.setState({contracts, loading: false})
    	})

	}

	updateContract = (contract) => {
		console.log(contract)
		let salary = {
        taxable: {
          base: this.calculateBaseSalary(contract),
          sep_1: this.calculateSEP1Salary(contract),
          sep_2: this.calculateSEP2Salary(contract),
          sep_3: this.calculateSEP3Salary(contract),
          brp_titulo: this.calculateBRPBonusSalary('titulo', contract),
          brp_mencion: this.calculateBRPBonusSalary('mencion', contract),
          ley: this.calculateLawBonusSalary('normal', contract),
          ley_pie: this.calculateLawBonusSalary('pie', contract)
        },
        non_taxable: {
          movilization: this.calculateMovilizationSalary(contract),
        }
      }
      console.log(contract.name)
      console.log(contract.salary)
      console.log( salary)
		//Calculate and Update salaries
		//Update 
		this.saveContract({...contract, salary:salary})
	}

	saveContract = (contract) => {
		console.log('In save')
		console.log(contract)
		if(contract.id != '') {
        FirebaseApi.databaseSet('/contracts/' + contract.id, 
          {...contract, last_modification: FirebaseApi.serverTimestamp()})
		}
	}
 
	 getStartOfDay = (detailed_grid, day_index) => {

      let start_time = ''
      detailed_grid.forEach((row, rowIndex) => {
        //Dont read the first row (shorter)
        if(rowIndex != 0) {
          if(glosary.includes(row[day_index].value.toLowerCase().trim()) && row[day_index].value.toLowerCase().trim() != ''){
            if(start_time == ''){
              start_time = row[1].value
            }
          }
        }
      })
      return start_time
    }

    getEndOfDay = (detailed_grid, day_index) => {
      let end_time = ''
      let reversed_grid  = detailed_grid.slice(0).reverse()
      reversed_grid.forEach((row, rowIndex) => {
        //Dont read the first row (shorter, reversed)     
        if(rowIndex < detailed_grid.length -1 ) {
          if(glosary.includes(row[day_index].value.toLowerCase().trim())  && row[day_index].value.toLowerCase().trim() != '' ){
            if(end_time == ''){
              end_time = row[2].value
            }
          }
        }
      }) 
      return end_time 
    }
	roundNearest5Tenth = (val) => {

      let decimal_part = val *100 % 100

      if(decimal_part >= 50) {
        return  Math.round( val * 2) / 2
      }

      else {
        let doubled = val * 2
        let modulo = doubled *100 % 100

        let rounded = modulo > 50 ? Math.round(doubled) / 2 : Math.floor(doubled) / 2

        return rounded
      }

    }

     computeMiddleClassroomMinutes = (contract) => {
      let minutes  = contract.overwrited.middle ? contract.overwrited_hours.middle * 60 : contract.categories_minutes.middle_classroom
      return isNaN(minutes) ? 0 : minutes
    }

    computeHighClassroomMinutes = (contract) => {
      let minutes  = contract.overwrited.high ? contract.overwrited_hours.high * 60: contract.categories_minutes.high_classroom
      return isNaN(minutes) ? 0 : minutes
    }

    computeBreakMinutes = (contract) => {
      let minutes  = contract.categories_minutes.break
      return isNaN(minutes) ? 0 : minutes
    }

    computeNonAcademicMinutes = (contract) => {
      let minutes  =  contract.categories_minutes.non_academic
      return isNaN(minutes) ? 0 : minutes
    }

    computeColaborationMinutes = (contract) => {
      let minutes = contract.categories_minutes.colab
      return isNaN(minutes) ? 0 : minutes
    }
    computeSEP1Minutes = (contract) => {
      let minutes  = contract.overwrited.sep_1 ? contract.overwrited_hours.sep_1 *60: contract.categories_minutes.sep_1
      return isNaN(minutes) ? 0 : minutes
    }

    computeSEP2Minutes = (contract) => {
      let minutes  = contract.overwrited.sep_2 ? contract.overwrited_hours.sep_2 *60 : contract.categories_minutes.sep_2
      return isNaN(minutes) ? 0 : minutes
    }

    computeSEP3Minutes = (contract) => {
      let minutes = contract.categories_minutes.sep_3
      return isNaN(minutes) ? 0 : minutes
    }

	getDistributedClassroomMinutesForSalary = (contract) => {
	
      let distributedMinutes = this.getDistributedClassroomMinutes('counter', contract)
      if(contract.overwrited.middle) {
        distributedMinutes.middle = contract.overwrited_hours.middle * 60
      }

      if(contract.overwrited.high) {
        distributedMinutes.high = contract.overwrited_hours.high * 60
      }

      return distributedMinutes

  	}

  	getDistributedClassroomMinutes = (purpouse, contract) => {

      let middle_classroom_minutes = 0
      let high_classroom_minutes = 0
      let non_academic_minutes = 0
      let break_minutes = 0
      let colaboration_minutes = 0
      if (purpouse == 'salary') {
        middle_classroom_minutes = this.computeMiddleClassroomMinutes(contract)
        high_classroom_minutes = this.computeHighClassroomMinutes(contract)
        non_academic_minutes = this.computeNonAcademicMinutes(contract)
        break_minutes =  this.computeBreakMinutes(contract)
        colaboration_minutes = this.computeColaborationMinutes(contract)
      }
      else if (purpouse == 'restriction' || purpouse == 'counter') {
        middle_classroom_minutes = contract.categories_minutes.middle_classroom
        high_classroom_minutes = contract.categories_minutes.high_classroom
        non_academic_minutes = contract.categories_minutes.non_academic
        break_minutes =  contract.categories_minutes.break
        colaboration_minutes = contract.categories_minutes.colab
      }
      
      let pie_middle_classroom_minutes = contract.categories_minutes.pie_middle_classroom
      let pie_high_classroom_minutes = contract.categories_minutes.pie_high_classroom

      //On progress
      let yard_turn_minutes = contract.categories_minutes.yard_turn

      //Weighted proportion
      let middle_classroom_proportion = 0
      let high_classroom_proportion = 0
      if(contract.proportion_to_use == 'new') {
        let total_academic_minutes= middle_classroom_minutes + high_classroom_minutes
        middle_classroom_proportion = total_academic_minutes > 0 ?  middle_classroom_minutes / total_academic_minutes : 0.5
        high_classroom_proportion =  total_academic_minutes > 0 ?  high_classroom_minutes / total_academic_minutes : 0.5
      }
      else if(contract.proportion_to_use == 'old') {
        let total_old_hours = (contract.old_hours.middle_classroom + contract.old_hours.high_classroom)
        middle_classroom_proportion = contract.old_hours.middle_classroom / total_old_hours
        high_classroom_proportion = contract.old_hours.high_classroom / total_old_hours
      }

      //Distribute and sum non academic minutes
      middle_classroom_minutes+= middle_classroom_proportion * non_academic_minutes
      high_classroom_minutes+= high_classroom_proportion * non_academic_minutes
 


      //Distribute and sum break minutes
      middle_classroom_minutes+= middle_classroom_proportion * break_minutes
      high_classroom_minutes+= high_classroom_proportion * break_minutes

      //Sum Colaboration minutes
      middle_classroom_minutes+= middle_classroom_proportion * colaboration_minutes
      high_classroom_minutes+= high_classroom_proportion * colaboration_minutes

      //Sum PIE minutes
      middle_classroom_minutes+= pie_middle_classroom_minutes
      high_classroom_minutes+= pie_high_classroom_minutes

      //Sum yard turn minutes
      middle_classroom_minutes+= middle_classroom_proportion * yard_turn_minutes
      high_classroom_minutes+= high_classroom_proportion * yard_turn_minutes


      if(contract.overwrited.middle && purpouse == 'salary') {
        middle_classroom_minutes =  contract.overwrited_hours.middle*60
      }

      if(contract.overwrited.high && purpouse == 'salary') {
        high_classroom_minutes =  contract.overwrited_hours.high*60
      }

      return {middle: middle_classroom_minutes, high: high_classroom_minutes}

    }

    computeTotalMinutesFinal = (contract) => {
    	console.log('In tmf')
    	console.log(contract)
      let total_minutes = contract.total_minutes_final
      let distributedMinutes = this.getDistributedClassroomMinutes('counter', contract)
      
      //Dont consider schedule and hidden sep_1 minutes, they are fixed
      total_minutes-= contract.categories_minutes.non_visible_sep_1
      total_minutes-= contract.categories_minutes.sep_1
      //Add fixed sep_1 minutes
      total_minutes+= headship_hours[contract.headship.value].payable * 60

      //Substract float minutes because they are not defined yet
      //total_minutes-= contract.categories_minutes.float
      contract.categories_minutes.float == null ? '' :  total_minutes-= contract.categories_minutes.float

      if(contract.overwrited.middle) {
        //Substract counted middle minutes and add overwrited
        total_minutes-= distributedMinutes.middle
        total_minutes+= contract.overwrited_hours.middle * 60

      }

      if(contract.overwrited.high) {
        //Substract counted high minutes and add overwrited
        total_minutes-= distributedMinutes.high
        total_minutes+= contract.overwrited_hours.high * 60
        
      }

      if(contract.overwrited.sep_1) {
         //Substract counted sep 1 minutes and add overwrited
        total_minutes-= headship_hours[contract.headship.value].payable * 60
        total_minutes+= contract.overwrited_hours.sep_1 * 60

      }

      if(contract.overwrited.sep_2) {
        //Substract counted sep 2 minutes and add overwrited
        total_minutes -= contract.categories_minutes.sep_2
        total_minutes += contract.overwrited_hours.sep_2 * 60
      }
  
      // Not implemented yet
      /* 
      if(contract.overwrited.sep_3) {
        //Substract counted sep 2 minutes and add overwrited
        total_minutes -= contract.categories_minutes.sep_3
        total_minutes += contract.overwrited_hours.sep_3 * 60
      }*/
      return total_minutes


    }

	calculateBaseSalary = (contract) => {

      let middle_classroom_hour_price = year_wages[contract.startDate][contract.startPeriod].middle
      let high_classroom_hour_price = year_wages[contract.startDate][contract.startPeriod].high

      let minutes = this.getDistributedClassroomMinutesForSalary(contract)




      //Get hours from minutes, approximate to nearest 0.5
      let middle_classroom_hours = this.roundNearest5Tenth(minutes.middle /60)
      let high_classroom_hours = this.roundNearest5Tenth(minutes.high / 60)

      let base_salary = middle_classroom_hours * middle_classroom_hour_price + high_classroom_hours * high_classroom_hour_price

      return {salary: base_salary, middle_hours:middle_classroom_hours, high_hours: high_classroom_hours}
    
     }

    calculateSEP1Salary = (contract) => {

      let headship = contract.headship.value
      let sep_1_hour_price = 0
      if(headship == 'parvularia' || headship == 'básica_1_a_4' || headship == 'básica_5_a_6' || headship == 'básica_7_a_8') {
        sep_1_hour_price =  year_wages[contract.startDate][contract.startPeriod].middle
      }
      else if(headship == 'media')   {
        sep_1_hour_price = year_wages[contract.startDate][contract.startPeriod].high
      }


      //let sep_1_hours = Math.floor(contract.categories_minutes.sep_1 / 60)
      let sep_1_hours = 0
      if(contract.overwrited.sep_1) {
        sep_1_hours = contract.overwrited_hours.sep_1
      }
      else {
        sep_1_hours = headship_hours[headship].payable
      }
      return {salary:Math.floor(sep_1_hours * sep_1_hour_price), hours: sep_1_hours}
    }

    calculateSEP2Salary = (contract) => {

      
      let middle_classroom_hour_price = year_wages[contract.startDate][contract.startPeriod].middle
      let high_classroom_hour_price = year_wages[contract.startDate][contract.startPeriod].high

      //let middle_classroom_minutes = this.computeMiddleClassroomMinutes()
      //let high_classroom_minutes = this.computeHighClassroomMinutes() 

      let res = this.getDistributedClassroomMinutes('salary', contract)
      let middle_classroom_minutes = res.middle 
      let high_classroom_minutes = res.high

      let hour_price = 0 
      if(contract.sep_2_hour_type == 'middle') {
        hour_price = year_wages[contract.startDate][contract.startPeriod].middle
      }
      else if(contract.sep_2_hour_type == 'high') {
        hour_price = year_wages[contract.startDate][contract.startPeriod].high
      }
      else if(contract.sep_2_hour_type == 'weighted') {

        let middle_classroom_hours = this.roundNearest5Tenth(middle_classroom_minutes /60)
        let high_classroom_hours = this.roundNearest5Tenth(high_classroom_minutes /60)
        //Weighted hour price (for break and non_academic)
        if(contract.proportion_to_use == 'new') {

          //By minutes

          //let total_academic_minutes= middle_classroom_minutes + high_classroom_minutes
          //let middle_classroom_proportion = total_academic_minutes > 0 ?  middle_classroom_minutes / total_academic_minutes : 0.5
          //let high_classroom_proportion =  total_academic_minutes > 0 ?  high_classroom_minutes / total_academic_minutes : 0.5

          //By hours
          
          let total_academic_hours = middle_classroom_hours + high_classroom_hours
          let middle_classroom_proportion = total_academic_hours > 0 ? middle_classroom_hours / total_academic_hours : 0.5
          let high_classroom_proportion = total_academic_hours > 0 ? high_classroom_hours / total_academic_hours : 0.5    
          hour_price = middle_classroom_proportion * middle_classroom_hour_price + high_classroom_proportion * high_classroom_hour_price
        }
        else if(contract.proportion_to_use == 'old') {
          let total_old_hours = (contract.old_hours.middle_classroom + contract.old_hours.high_classroom)
          let middle_classroom_old_proportion = contract.old_hours.middle_classroom / total_old_hours
          let high_classroom_old_proportion = contract.old_hours.high_classroom / total_old_hours
          hour_price = middle_classroom_old_proportion * middle_classroom_hour_price + high_classroom_old_proportion * high_classroom_hour_price
        }
      }
      else if(contract.sep_2_hour_type == 'other') {
        hour_price = contract.sep_2_hour_value_other
      }


      let sep_2_hours =  this.roundNearest5Tenth(this.computeSEP2Minutes(contract) / 60)

      return {salary: Math.floor(sep_2_hours * hour_price), hours: sep_2_hours}

    }

    calculateSEP3Salary = (contract) => {
       let sep_3_hours =  this.roundNearest5Tenth(this.computeSEP3Minutes(contract) / 60)

       let {sep_3_hour_value} = contract

       return {salary: sep_3_hour_value * sep_3_hours, hours: sep_3_hours}
    }

    calculateLawBonusSalary = (type, contract) => {
      let ley_salary = 0
      let total_hours = 0
      if(contract.selected_schedule_type != undefined){
        //let total_hours = Object.values(contract.categories_minutes).reduce((a, b) => a + b) / 60
         total_hours = this.calculateTotalHours(contract)

        total_hours = total_hours > 44 ? 44 : total_hours

        if(type == 'normal') {
          if(contract.bonuses.ley) {
            let bonus_hour_price = this.getScheduleTypeData(contract.selectedOption.value).bonus_hour_price
            ley_salary = total_hours * bonus_hour_price
          }
        }
        else if( type == 'pie') {
          if(contract.bonuses.ley_pie) {
            let bonus_hour_price = this.getScheduleTypeData(contract.selectedOption.value).bonus_hour_price_PIE
            ley_salary = total_hours * bonus_hour_price
          }
        }
      }

      return {salary: Math.round(ley_salary), hours: total_hours}
    }

    calculateBRPBonusSalary = (type, contract) => {
        let brp_salary = 0
        //Round to nearest integer
        let total_hours = Math.round(this.calculateTotalHours(contract))
        total_hours = total_hours > 44 ? 44 : total_hours
        total_hours = isNaN(total_hours) ? 0 : total_hours
        let hour_price = 0
        if(type == 'titulo' && contract.bonuses.brp_titulo) {
          brp_salary = brp_bonus_wages[total_hours].titulo
        }
        else if(type == 'mencion' && contract.bonuses.brp_mencion) {
          brp_salary = brp_bonus_wages[total_hours].mencion
        }

        return {salary: brp_salary, hours: total_hours}
    }

    calculateMovilizationSalary = (contract) => {
    	if(contract.detailed_grid == null) {
    		return 0
    	}
      let movilization_salary = 0
      let working_days = 0 
      if(!(contract.detailed_grid[1] == null)) {
        for(let index = 3; index < contract.detailed_grid[1].length; index++){
          let day_start = this.getStartOfDay(contract.detailed_grid, index)
          let day_end =  this.getEndOfDay(contract.detailed_grid, index)
          if(day_start != '') {
            working_days+= 1
          }
        }
      }
      if(! (contract.selected_schedule_type == null)) {
        let schedule_type = this.getScheduleTypeData(contract.selectedOption.value)
        schedule_type.movilization_bonus != null ? movilization_salary = schedule_type.movilization_bonus[working_days] : movilization_salary = 0
        
      }
      return Math.round(movilization_salary)
    }

	 calculateTotalHours = (contract) => {
      let headship = contract.headship.value
      let base_salary_object= this.calculateBaseSalary(contract)
      let base_hours = base_salary_object.middle_hours + base_salary_object.high_hours
      let sep_1_hours = 0
        if(contract.overwrited.sep_1) {
          sep_1_hours = contract.overwrited_hours.sep_1
        }
        else {
          sep_1_hours = headship_hours[headship].payable
        }
        let sep_2_hours =  this.roundNearest5Tenth(this.computeSEP2Minutes(contract) / 60)
        let sep_3_hours =  this.roundNearest5Tenth(this.computeSEP3Minutes(contract) / 60)

        return base_hours + sep_1_hours + sep_2_hours + sep_3_hours
    }
     //Now it gets the values from wages.js. In the future it should get values from DB
    getScheduleTypeData = (schedule_type) => {
      switch(schedule_type) {

        case 'san-jose':
          return san_jose_type;
        case 'san-joaquin':
          return san_joaquin_type
        case 'san-juan':
          return san_juan_type
        default:
          return null
      }
    }
    

	render() {
		return (
				<div style={{display: 'flex'}}>
					<button onClick={() => this.fetchContracts()} disabled>Actualizar</button>
					<div className='title-spinner'  style={this.state.loading ? {display:'flex'} : {display:'none'} }>
			        	<i className="fas fa-circle-notch fa-spin fa-2x" aria-hidden="true"></i>
			        </div>
				</div>
			)
	}
}

export default Updater


// WEBPACK FOOTER //
// ./src/components/helpers/Updater.js